import { Injectable } from '@angular/core';

import * as _ from 'lodash';

import { Toast, ToastData } from './class/toast';

/**
 * Toasts podem ser criados facialmente utilizando esse serviÃ§o
 *
 * @example
 * constructor(private _toastService: ToastService) {
 *    this._toastService.open({ message: 'Works!', duration: 0, showAction: true, actionText: 'Fechar' });
 * }
 */

@Injectable()
export class ToastService {

  public toasts: Array<Toast> = [];

  private _toast_autoincrement = 1;

  /**
   * Cria e exibe automaticamente o toast. Alias para o mÃ©todo "show"
   */
  public open = this.show;

  /**
   * Cria e exibe automaticamente o toast
   */
  public show(settings: ToastData): Toast {
    const toast = this.create(settings);

    toast.show();

    return toast;
  }

  /**
   * Cria mas NÃO exibe automaticamente o toast
   */
  public create(settings: ToastData): Toast {
    const id = this._toast_autoincrement;

    const toast = new Toast({
      id: id,
      message: settings.message,
      duration: settings.duration,
      show_close_button: settings.show_close_button,
      close_button_text: settings.close_button_text
    }, this);

    this.toasts.push(toast);

    this._toast_autoincrement++;

    return toast;
  }

  /**
   * Destroi a instancia e componente de um toast
   */
  public destroy(id: number) {
    const toast_index = this._getToastIndexById(id);
    if (_.isNumber(toast_index)) { this.toasts.splice(toast_index, 1); }
  }

  private _getToastIndexById(id: number): number {
    if (!_.isNumber(id)) { return null; }

    let toast_index = null;
    this.toasts.forEach((_toast, index) => {
      if (!_.isNumber(toast_index) && _toast.id === id) { toast_index = index; }
    });

    return toast_index;
  }
}
